enum RecordSummaryPeriod {
  LAST_30_DAYS = "last_30_days",
  LAST_3_MONTHS = "last_3_months",
  LAST_6_MONTHS = "last_6_months",
  LAST_12_MONTHS = "last_12_months",
}

export default RecordSummaryPeriod;
